import { render, staticRenderFns } from "./StudentActivationSlidebar.vue?vue&type=template&id=1dbbf104"
import script from "./StudentActivationSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentActivationSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports